import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import type { CascadingSelectValuePair } from '@atlassian/jira-issue-field-cascading-select-editview-full/src/ui/cascading-select/types.tsx';
import type { CascadingSelectFieldValue } from '../../../../common/field-types/cascading-select/types.tsx';
import { getCascadingSelectStringValue } from '../../../../common/field-types/cascading-select/value/index.tsx';

export const CascadingSelectRead = ({
	value,
}: {
	value: CascadingSelectFieldValue | CascadingSelectValuePair | null;
}) => {
	if (value == null) {
		return null;
	}

	return <Box xcss={containerStyles}>{getCascadingSelectStringValue(value)}</Box>;
};

const containerStyles = xcss({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	width: '100%',
	display: 'block',
});
